import { Component, Inject, ViewChild, forwardRef } from "@angular/core";
import { NgForm } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { ErrorMessages } from "../../common/constants";
import { ActionIssueType, ActionStatus } from "../../model";
import { ActionIssueTypeService } from "../../service/action-issue-type.service";
import { ErrorUtility } from "../../utility/error-utility";


@Component({
    selector: 'mark-as-done-with-issue-action-dialog',
    template: require('./mark-as-done-with-issue-action-dialog.component.html')
})
export class MarkAsDoneWithIssueActionDialogComponent {

    @ViewChild('form') form: NgForm;

    actionStatus: ActionStatus;
    error: string;
    issueTypes: ActionIssueType[];
    loaded: boolean;

    constructor(
        @Inject(forwardRef(() => MatDialogRef)) public dialogRef: MatDialogRef<MarkAsDoneWithIssueActionDialogComponent>,
        @Inject(forwardRef(() => ActionIssueTypeService)) private actionIssueTypeService: ActionIssueTypeService,
        @Inject(MAT_DIALOG_DATA) data
    ) {
        this.actionStatus = data.actionStatus;
        this.loadActionIssueTypes();
    }

    private loadActionIssueTypes(): void {
        this.actionIssueTypeService.getAllIssueTypes().then(types => {
            this.issueTypes = types;
            this.loaded = true;
        }).catch(err => {
            this.error = ErrorUtility.getMessage(err, ErrorMessages.GET_DATA_ERROR);
            this.loaded = true;
        });
    }

    confirm(): void {
        this.dialogRef.close(this.form.form.getRawValue());
    }

}